module.exports = __webpack_public_path__ + "media/images/countryrect/ax-aef4645e660e1b846abed09a10872f94.svg";